
import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import LoginFrom, { CodeForm } from "@/lib/form/login/LoginFrom";
import { ElForm } from "element-ui/types/form";
import _ from "lodash-es";
import Info from "../lib/model/account/info";
import Url from "@/lib/common/url";
import Auth from "@/lib/common/auth";

@Component({
  components: {
    Header: AuthHeader
  }
})
export default class AiLogin extends Vue {
  seconds = 0;
  interval = 0;
  codeForm: CodeForm = new CodeForm();
  loginFrom: LoginFrom = new LoginFrom();
  rules = this.loginFrom.rules();
  formElement!: ElForm;
  sendingCaptchaLock = false;
  loginLock = false;
  returnUrl = Url.query("returnUrl");

  mounted() {
    this.formElement = this.$refs["form"] as ElForm;
  }

  created() {
    document.title = "海纳：登录-大规模AI面试专业服务商";
    console.log("aiLogin created: ", Auth.token, Auth.userId, Auth.companyId);
    // if (Auth.token && Auth.userId && Auth.companyId) {
    //   window.location.href = "/exam/paper?companyId=" + Auth.companyId;
    // } else {
    //   Auth.logout();
    //   Auth.token = "";
    // }
  }

  getCode() {
    this.formElement.validateField("mobile", message => {
      if (_.isEmpty(message)) {
        if (this.sendingCaptchaLock) {
          return;
        }
        if (this.seconds > 0) {
          return;
        }
        this.sendingCaptchaLock = true;
        // 获取验证码
        this.codeForm.phone = this.loginFrom.phone;
        Info.getCode(this.codeForm)
          .then(() => {
            this.seconds = 60;
            this.interval = setInterval(() => {
              this.seconds--;
              if (this.seconds <= 0) {
                clearInterval(this.interval);
                this.sendingCaptchaLock = false;
              }
            }, 1000);
          })
          .catch(() => {
            this.sendingCaptchaLock = false;
          });
      }
    });
  }

  login() {
    if (this.loginLock) {
      return;
    }
    this.formElement.validate().then(valid => {
      if (valid) {
        this.loginLock = true;
        return Info.loginByMobileCaptcha(this.loginFrom)
          .then(() => {
            window.location.href = "/exam/paper";
          })
          .finally(() => {
            this.loginLock = false;
          });
      }
    });
  }
}
